import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, createBlock as _createBlock, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e682630"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "formContainer",
  class: "container page-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "alert alert-warning" }
const _hoisted_4 = { class: "alert-body" }
const _hoisted_5 = { class: "alert-heading" }
const _hoisted_6 = { class: "alert-text" }
const _hoisted_7 = {
  key: 1,
  class: "alert alert-warning mt-5"
}
const _hoisted_8 = { class: "alert-body" }
const _hoisted_9 = { class: "alert-heading" }
const _hoisted_10 = { class: "alert-text" }
const _hoisted_11 = { class: "row mt-5" }
const _hoisted_12 = { class: "col-9 col-lg-9" }
const _hoisted_13 = { class: "font-lead" }
const _hoisted_14 = { class: "col-3 col-lg-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#add" })
], -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 col-lg-12" }
const _hoisted_19 = {
  class: "tabnav",
  role: "tablist",
  id: "tabs"
}
const _hoisted_20 = {
  "aria-controls": "tabpanel_kontaktinfo",
  id: "tab_kontaktinfo",
  class: "tabnav-item",
  role: "tab",
  "aria-selected": "true"
}
const _hoisted_21 = {
  class: "tabnav-panel",
  "aria-hidden": "true",
  role: "tabpanel",
  id: "tabpanel_kontaktinfo",
  "aria-labelledby": "tab_kontaktinfo"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "container page-container col-12 col-md-12" }
const _hoisted_24 = {
  key: 0,
  class: "alert alert-error mt-0 mb-8",
  role: "alert",
  "aria-atomic": "true"
}
const _hoisted_25 = { class: "alert-body" }
const _hoisted_26 = { class: "alert-heading" }
const _hoisted_27 = { class: "alert-text nobullet-list" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  style: {"margin-top":"0"},
  id: "kontaktOverskrift"
}
const _hoisted_30 = { class: "form-hint" }
const _hoisted_31 = {
  "aria-label": "Kontaktoplysninger navigation",
  class: "page-navigation d-print-none"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  class: "tabnav-panel",
  "aria-hidden": "true",
  role: "tabpanel",
  tabindex: 1,
  id: "tabpanel_udbudsinfo",
  "aria-labelledby": "tab_udbudsinfo"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = {
  key: 0,
  class: "col-12 col-md-3 sidebar-col"
}
const _hoisted_37 = { class: "overflow-menu overflow-menu--open-right overflow-menu--lg-no-responsive" }
const _hoisted_38 = {
  class: "button-overflow-menu js-dropdown",
  "data-js-target": "overflow4",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  "aria-hidden": "true",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#arrow-drop-down" })
], -1))
const _hoisted_40 = {
  class: "overflow-menu-inner",
  id: "stepByStepMenu"
}
const _hoisted_41 = { "aria-label": "Trin navigation" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  for: "product-index-dropdown",
  class: "form-label"
}
const _hoisted_44 = ["value"]
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  class: "sidenav-list",
  role: "menu"
}
const _hoisted_47 = ["id", "onClick"]
const _hoisted_48 = ["id"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = ["id"]
const _hoisted_51 = {
  key: 0,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#check" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 1,
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#error" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 0,
  class: "alert alert-error mt-0 mb-8",
  role: "alert",
  "aria-atomic": "true"
}
const _hoisted_58 = { class: "alert-body" }
const _hoisted_59 = { class: "alert-heading" }
const _hoisted_60 = { class: "alert-text nobullet-list" }
const _hoisted_61 = ["href"]
const _hoisted_62 = {
  key: 1,
  style: {"margin-top":"0"},
  id: "blanketOverskrift"
}
const _hoisted_63 = {
  key: 2,
  class: "font-lead"
}
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { key: 3 }
const _hoisted_66 = {
  key: 4,
  class: "form-group"
}
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = {
  "aria-label": "Blanket navigation",
  class: "page-navigation d-print-none"
}
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["disabled"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#send" })
], -1))
const _hoisted_74 = ["disabled"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#send" })
], -1))
const _hoisted_76 = {
  "aria-controls": "tabpanel_og_oplysninger",
  id: "tab_og_oplysninger",
  class: "tabnav-item",
  role: "tab",
  "aria-selected": "true"
}
const _hoisted_77 = {
  class: "tabnav-panel",
  "aria-hidden": "true",
  role: "tabpanel",
  tabindex: 2,
  id: "tabpanel_og_oplysninger",
  "aria-labelledby": "tab_og_oplysninger"
}
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#save" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_FormularFelt = _resolveComponent("FormularFelt")!
  const _component_TGOpsummering = _resolveComponent("TGOpsummering")!
  const _component_TGResultat = _resolveComponent("TGResultat")!
  const _component_TGPublishReplaceModal = _resolveComponent("TGPublishReplaceModal")!
  const _component_Opsummering = _resolveComponent("Opsummering")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.formular.originalBlanketId || this.editOffer)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.rediger-indsendt.overskrift' }, null, 8, ["tekstNoegle"])
              ]),
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.rediger-indsendt.beskrivelse' }, null, 8, ["tekstNoegle"])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isOGOnBehalfOfTG)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.advarsel.og-udfylder-paa-vegne-af-tg.overskrift' }, null, 8, ["tekstNoegle"])
            ]),
            _createElementVNode("p", _hoisted_10, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.advarsel.og-udfylder-paa-vegne-af-tg.tekst' }, null, 8, ["tekstNoegle"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", null, _toDisplayString(this.title), 1),
        _createElementVNode("p", _hoisted_13, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.underoverskrift' }, null, 8, ["tekstNoegle"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (this.nuvaerendeTrin > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button button-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.addNewProduct())),
              id: "add-product-button",
              disabled: this.formular.products.length >= this.productLimit
            }, [
              _hoisted_16,
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.tilfoej-nyt-produkt' }, null, 8, ["tekstNoegle"])
            ], 8, _hoisted_15))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", _hoisted_20, [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.kontaktoplysninger.tabnavn' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _createElementVNode("section", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_ctx.hentFejlContactInfo().length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", _hoisted_26, [
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.alert.overskrift' }, null, 8, ["tekstNoegle"])
                        ]),
                        _createElementVNode("ul", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hentFejlContactInfo(), (fejl) => {
                            return (_openBlock(), _createElementBlock("li", { key: fejl }, [
                              _createElementVNode("a", {
                                class: "function-link",
                                href: '#' + _ctx.genererDomId(fejl.tcoElementName)
                              }, _toDisplayString(fejl.fejlbesked), 9, _hoisted_28)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("h2", _hoisted_29, _toDisplayString(this.formular.contactInfo?.overskrift), 1),
                _createElementVNode("span", _hoisted_30, _toDisplayString(this.formular.contactInfo?.beskrivelse), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.formular.contactInfo?.felter, (felt) => {
                  return (_openBlock(), _createBlock(_component_FormularFelt, {
                    key: felt,
                    felt: felt,
                    maerkat: felt.maerkat,
                    readOnly: felt.readOnly
                  }, null, 8, ["felt", "maerkat", "readOnly"]))
                }), 128)),
                _createElementVNode("nav", _hoisted_31, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.gemKladde(false, false); _ctx.forsaetTilBlanket();}),
                    onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_ctx.gemKladde(false, false); _ctx.skiftTilUdbudsInfo(); _ctx.aktiverValidering(this.formular.contactInfo?.felter); _ctx.scrollToTop();}, ["enter"])),
                    class: "button button-secondary",
                    id: "fortsaetTilBlanketKnap",
                    disabled: _ctx.isOGOnBehalfOfTG && _ctx.isOGErrorCVR,
                    tabindex: 0
                  }, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.fortsaet-til-blanket' }, null, 8, ["tekstNoegle"])
                  ], 40, _hoisted_32),
                  (_ctx.maaGaaTilOpsummering)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.gotoOpsummering(); _ctx.gemKladde(false, false); }),
                        class: "button button-tertiary",
                        id: "opsummeringsKnap2"
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.videre-til-opsummering' }, null, 8, ["tekstNoegle"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            "aria-controls": "tabpanel_udbudsinfo",
            id: "tab_udbudsinfo",
            class: "tabnav-item",
            role: "tab",
            "aria-selected": false,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.SkipContact())),
            disabled: _ctx.isOGOnBehalfOfTG && _ctx.isOGErrorCVR
          }, [
            _createElementVNode("span", null, _toDisplayString(this.getMainTabLabel()), 1)
          ], 8, _hoisted_33),
          _createElementVNode("section", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              (_ctx.nuvaerendeTrin < _ctx.samletAntalTrin)
                ? (_openBlock(), _createElementBlock("aside", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("button", _hoisted_38, [
                        _createTextVNode(" Trin " + _toDisplayString(_ctx.nuvaerendeTrin) + " af " + _toDisplayString(_ctx.samletAntalTrin) + " ", 1),
                        _hoisted_39
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("nav", _hoisted_41, [
                          (_ctx.nuvaerendeTrin > 1 && _ctx.nuvaerendeTrin < 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("label", _hoisted_43, [
                                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.produktvaelger.maerkat' }, null, 8, ["tekstNoegle"])
                                ]),
                                _createElementVNode("select", {
                                  class: "form-select mb-6",
                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (this.skiftTilProduktTrin($event.target.value - 1, 2))),
                                  id: "product-index-dropdown",
                                  value: this.currentProductIndex + 1
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.numberOfProducts, (n) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: n,
                                      value: n
                                    }, _toDisplayString(this.getProductNameForDropdown(n)), 9, _hoisted_45))
                                  }), 128))
                                ], 40, _hoisted_44)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("ul", _hoisted_46, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductFormularAt(_ctx.currentProductIndex)?.trin, (trin) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass({ current: trin.trin === _ctx.nuvaerendeTrin }),
                                role: "none",
                                key: trin.id
                              }, [
                                _createElementVNode("a", {
                                  id: 'tco_trin_a_' + trin.trin,
                                  onClick: ($event: any) => (_ctx.skiftTrin(trin.trin, true)),
                                  href: "javascript:void(0)",
                                  class: "no",
                                  role: "menuitem"
                                }, [
                                  _createElementVNode("div", {
                                    class: "d-inline-block",
                                    id: 'tco_trin_' + trin.trin
                                  }, [
                                    _createTextVNode(_toDisplayString(trin.trin) + ". " + _toDisplayString(trin.overskrift) + " ", 1),
                                    (trin.trin === _ctx.nuvaerendeTrin)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.valgt' }, null, 8, ["tekstNoegle"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_48),
                                  _createElementVNode("span", {
                                    class: "sidenav-icon",
                                    id: 'tco_trin_valid_' + trin.trin
                                  }, [
                                    (_ctx.hentFejl(trin.trin).length === 0
                               && trin.felter?.length > 0
                               && _ctx.getTrinNumberOutOfTotal(trin.trin) < this.nuvaerendeMaksTrin && _ctx.isMandatoryFilled(trin.trin))
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_53))
                                      : _createCommentVNode("", true),
                                    ((_ctx.hentFejl(trin.trin).length > 0
                               || !_ctx.isMandatoryFilled(trin.trin))
                               && _ctx.getTrinNumberOutOfTotal(trin.trin) < this.nuvaerendeMaksTrin)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_54, _hoisted_56))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_50)
                                ], 8, _hoisted_47)
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("main", {
                class: _normalizeClass(["container page-container col-12", _ctx.nuvaerendeTrin === _ctx.samletAntalTrin ? 'col-md-12': 'col-md-9']),
                id: "main-content"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    id: "tilbageKnap",
                    class: _normalizeClass('back-link d-none d-lg-inline-block'),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onBackButtonClick && _ctx.onBackButtonClick(...args))),
                    onKeydown: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onBackButtonClick && _ctx.onBackButtonClick(...args)), ["enter"])),
                    tabindex: 0
                  }, [
                    _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.tilbage' }, null, 8, ["tekstNoegle"])
                  ], 32)
                ]),
                (_ctx.hentFejl(_ctx.nuvaerendeTrin).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("p", _hoisted_59, [
                          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.alert.overskrift' }, null, 8, ["tekstNoegle"])
                        ]),
                        _createElementVNode("ul", _hoisted_60, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hentFejl(_ctx.nuvaerendeTrin), (fejl) => {
                            return (_openBlock(), _createElementBlock("li", { key: fejl }, [
                              _createElementVNode("a", {
                                class: "function-link",
                                href: '#' + _ctx.genererDomId(fejl.tcoElementName)
                              }, _toDisplayString(fejl.fejlbesked), 9, _hoisted_61)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hentNuvaerendeTrin()?.overskrift)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_62, _toDisplayString(_ctx.hentNuvaerendeTrin()?.overskrift), 1))
                  : _createCommentVNode("", true),
                (_ctx.hentNuvaerendeTrin()?.undertitel)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.hentNuvaerendeTrin()?.undertitel), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  innerHTML: _ctx.hentNuvaerendeTrinBeskrivelse()
                }, null, 8, _hoisted_64),
                (_ctx.nuvaerendeTrin < _ctx.samletAntalTrin)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nuvaerendeFelter.filter(f => f.felttype !== _ctx.FeltType.HIDDEN), (felt) => {
                        return (_openBlock(), _createBlock(_component_FormularFelt, {
                          key: felt,
                          felt: felt,
                          maerkat: felt.maerkat,
                          readOnly: false,
                          validators: _ctx.feltValidators.get(felt.tcoElementName),
                          validateOnKeyUp: felt.tcoElementName === 'frontendNumberOfProductVariants'
                        }, null, 8, ["felt", "maerkat", "validators", "validateOnKeyUp"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.nuvaerendeTrin === _ctx.samletAntalTrin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      (!_ctx.onResultPage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createVNode(_component_TGOpsummering, {
                              formular: this.formular,
                              editable: true
                            }, null, 8, ["formular"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.onResultPage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createVNode(_component_TGResultat, {
                              formular: this.formular
                            }, null, 8, ["formular"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("nav", _hoisted_69, [
                  (_ctx.nuvaerendeTrin < _ctx.samletAntalTrin && _ctx.nuvaerendeTrin % _ctx.numberOfTrinPerProduct !== 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.nuvaerendeTrin === 1 && _ctx.hentFejl(_ctx.nuvaerendeTrin).length > 0,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.gemKladde(false, false); _ctx.skiftTrin(1);}),
                        class: "button button-secondary",
                        id: "naesteKnap"
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.naeste' }, null, 8, ["tekstNoegle"])
                      ], 8, _hoisted_70))
                    : _createCommentVNode("", true),
                  (_ctx.nuvaerendeTrin % _ctx.numberOfTrinPerProduct === 0 && (_ctx.nuvaerendeTrin * (_ctx.currentProductIndex + 1)) < (_ctx.samletAntalTrin-1))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.gemKladde(false, false); _ctx.nextProduct();}),
                        class: "button button-primary",
                        id: "naesteProdukt",
                        style: {"margin-right":"30px"}
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.naeste-produkt' }, null, 8, ["tekstNoegle"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.nuvaerendeTrin < _ctx.samletAntalTrin && (_ctx.nuvaerendeTrin % _ctx.numberOfTrinPerProduct === 0 || _ctx.maaGaaTilOpsummering))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: _normalizeClass(["button", (_ctx.nuvaerendeTrin * (_ctx.currentProductIndex + 1)) < (_ctx.samletAntalTrin-1)? 'button-secondary' : 'button-primary']),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.gotoOpsummering(); _ctx.gemKladde(false, false)}),
                        id: "videreOpsummering"
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.videre-til-opsummering' }, null, 8, ["tekstNoegle"])
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.nuvaerendeTrin === _ctx.samletAntalTrin && !this.onResultPage)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.gemFormular(true, false); _ctx.onResultPage = true}),
                        class: "button button-primary",
                        disabled: _ctx.hentFejl()?.length > 0 || _ctx.hentFejlContactInfo()?.length > 0 || _ctx.savingDraftInProgress,
                        id: "gemKnap"
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.gaa-videre-til-resultatsiden' }, null, 8, ["tekstNoegle"])
                      ], 8, _hoisted_71))
                    : _createCommentVNode("", true),
                  (_ctx.nuvaerendeTrin === _ctx.samletAntalTrin && this.onResultPage)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        (this.formular.originalBlanketId || this.editOffer)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button button-primary",
                                disabled: _ctx.hentFejl()?.length > 0 || _ctx.hentFejlContactInfo()?.length > 0 || _ctx.savingDraftInProgress,
                                "data-micromodal-trigger": 'publish-replace-modal',
                                id: "send-button-republish"
                              }, [
                                _hoisted_73,
                                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.send-tilbud-til-ordregiver' }, null, 8, ["tekstNoegle"])
                              ], 8, _hoisted_72),
                              _createVNode(_component_TGPublishReplaceModal, {
                                onPublishChoice: _ctx.publish,
                                modalId: "publish-replace-modal"
                              }, null, 8, ["onPublishChoice"])
                            ], 64))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.publish())),
                              class: "button button-primary",
                              disabled: _ctx.hentFejl()?.length > 0 || _ctx.hentFejlContactInfo()?.length > 0 || _ctx.savingDraftInProgress,
                              id: "send-button"
                            }, [
                              _hoisted_75,
                              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.send-tilbud-til-ordregiver' }, null, 8, ["tekstNoegle"])
                            ], 8, _hoisted_74))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.nuvaerendeTrin === _ctx.samletAntalTrin && !this.onResultPage && !_ctx.savingDraftInProgress)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        type: "button",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.printOpsummering())),
                        class: "button button-unstyled button-underline",
                        id: "print-opsummering-button"
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvitteringTG.knap.downloadopsummering' }, null, 8, ["tekstNoegle"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.nuvaerendeTrin === _ctx.samletAntalTrin && this.onResultPage && !_ctx.savingDraftInProgress)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.printResultat())),
                        class: "button button-unstyled button-underline",
                        id: "print-resultat-button"
                      }, [
                        _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.kvitteringTG.knap.downloadresultat' }, null, 8, ["tekstNoegle"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("button", _hoisted_76, [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.ordregivers-oplysninger.tabnavn' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _createElementVNode("section", _hoisted_77, [
            (!_ctx.udbudId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.udbud-valg-mangler.beskrivelse' }, null, 8, ["tekstNoegle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.udbudId)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_79, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.opsummering-og-oplysninger.beskrivelse' }, null, 8, ["tekstNoegle"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.udbudId)
              ? (_openBlock(), _createBlock(_component_Opsummering, {
                  key: 2,
                  formular: this.formular.ogInformation,
                  editable: false
                }, null, 8, ["formular"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (this.nuvaerendeTrin > 1)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.gemKladde(false, true))),
          id: "gemKladdeKnap",
          href: "javascript:void(0)",
          class: "function-link"
        }, [
          _hoisted_80,
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.blanket.tg-blanket.knap.gem-kladde' }, null, 8, ["tekstNoegle"])
        ]))
      : _createCommentVNode("", true)
  ]))
}